import { useContext } from "react";
import ImageAspectRatioCacheContext from "context/ImageAspectRatioCacheContext";
import { normalizeImageURLForImageAspectRatioCache } from "../utils/normalizeImageURLForImageAspectRatioCache";

export function useCachedImageAspectRatio(source) {
  const { cache: imageAspectRatioCache } = useContext(
    ImageAspectRatioCacheContext,
  );

  const normalizedSource = normalizeImageURLForImageAspectRatioCache(source);

  return imageAspectRatioCache[normalizedSource];
}
